export const agenda = {
  agendaDuration: 'duur',
  agendaCurtainCopy: 'Kopieer link',
  agendaCurtainFlag: 'Markeer inhoud',
  agendaCurtainFlagSent: 'Inhoud gerapporteerd',
  agendaLinkCopied: 'Link gekopieerd!',
  agendaStartsAt: 'Begint om ',
  agendaEndsAt: 'Eindigt om ',
  agendaSpeakers: 'Sprekers',
  agendaSeeAllSpeakers: 'Bekijk alles',
  agendaAddToSchedule: 'Toevoegen aan mijn planning',
  agendaRemoveFromSchedule: 'Verwijderen uit mijn planning',
  agendaAddedToSchedule: 'Toegevoegd aan mijn planning!',
  agendaRemovedFromSchedule: 'Verwijderd uit mijn planning!',
  agendaCalendar: 'Kalender',
  agendaAddToCalendar: 'Toevoegen aan de systeemkalender?',
  agendaCalendarSkip: 'Overslaan',
  agendaCalendarAdd: 'Toevoegen',
  agendaNow: 'NU',
  agendaModerators: 'Moderators'
}
